<template>
  <svg viewBox="-10 -10 520 520" width="520" height="520" xmlns="http://www.w3.org/2000/svg">
    <path fill="currentColor" d="M 280 20 L 510 20 L 510 50 L 280 50 Z M 280 88.997 L 480 88.997 L 480 118.997 L 280 118.997 Z M 280 158.997 L 480 158.997 L 480 188.997 L 280 188.997 Z M 280 305 L 510 305 L 510 335 L 280 335 Z M 280 373.997 L 480 373.997 L 480 403.997 L 280 403.997 Z M 280 443.997 L 480 443.997 L 480 473.997 L 280 473.997 Z M 220 -10 L 220 220 L -10 220 L -10 -10 Z M 20 190 L 190 190 L 190 20 L 20 20 Z M 220 280 L 220 510 L -10 510 L -10 280 Z M 20 480 L 190 480 L 190 310 L 20 310 Z"/>
  </svg>
</template>

<script>

export default {
  name: 'IconList',
};
</script>

<style scoped lang="less">
</style>
